import React from "react";
import { mergeKpiConfigs } from "../config";

const BackValue = ({
  backValue,
  value,
  backValueConfig = {},
  wrapperClassName,
  className,
  option,
}) => {
  ({ backValueConfig } = mergeKpiConfigs(option, {
    backValueConfig,
  }));
  const resolvedWrapperClass =
    wrapperClassName ?? backValueConfig?.wrapperClassName;
  const resolvedClass = className ?? backValueConfig?.className;
  const isBackValueNumber = typeof backValue === "number";
  //console.log(isBackValueNumber ? 1 : 0);

  // if isBackValueNumber true then
  const percentageChange =
    typeof backValue === "number" && backValue !== 0
      ? ((Number(value) - backValue) / backValue) * 100
      : 0;

  return (
    <div className={backValueConfig.wrapperClassName}>
      {backValue !== "" &&
        (isBackValueNumber ? (
          backValue !== 0 && percentageChange !== 0 ? (
            <div
              className={`flex items-center gap-1 ${
                percentageChange > 0
                  ? resolvedClass ??
                    "text-success bg-success/10 px-1 py-0.5 rounded"
                  : "text-danger bg-danger/10 px-1 py-0.5 rounded"
              }`}
            >
              {percentageChange > 1 ? (
                <span className={`material-symbols-outlined text-[14px]!`}>
                  trending_up
                </span>
              ) : (
                <span className={`material-symbols-outlined text-[14px]!`}>
                  trending_down
                </span>
              )}
              <div className={`text-[12px]! font-bold`}>
                {percentageChange.toFixed(0)}%
              </div>
            </div>
          ) : null
        ) : (
          <div className={backValueConfig.className}>{backValue}</div>
        ))}
    </div>
  );
};

export default BackValue;
